import React, { useState, useEffect } from "react";
import { useAsyncResponse } from "./JobStatusHooks";

// This component is a wrapper around the useAsyncResponse hook.
export default function AsyncResponse({ asyncResponse, onComplete, onError }) {
  const { json } = useAsyncResponse({ asyncResponse, onError });

  useEffect(
    () => {
      if (!json) return;
      onComplete && onComplete(json);
    },
    [json]
  );

  return null;
}
